"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Presentation: ['presentation', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.375 18.375 A2.625 2.625 0 1 0 22.625 18.375 A2.625 2.625 0 1 0 17.375 18.375 Z', 'M23.249,23.25a4.269,4.269,0,0,0-6.5,0', 'M1.373 18.375 A2.625 2.625 0 1 0 6.623 18.375 A2.625 2.625 0 1 0 1.373 18.375 Z', 'M7.247,23.25a4.269,4.269,0,0,0-6.5,0', 'M9.578 3.375 A2.625 2.625 0 1 0 14.828 3.375 A2.625 2.625 0 1 0 9.578 3.375 Z', 'M15.452,8.25a4.269,4.269,0,0,0-6.5,0', 'M5.775,16.443l.833-4.4a.935.935,0,0,1,.891-.8h9a.935.935,0,0,1,.891.8l.833,4.4']],
  TeamMeetingMessageQuestion1: ['team-meeting-message-question_1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.249 15.750 A3.000 3.000 0 1 0 8.249 15.750 A3.000 3.000 0 1 0 2.249 15.750 Z', 'M9.473,23.25a4.474,4.474,0,0,0-8.449,0', 'M21.516,14.589a3,3,0,0,1-5.192,2.927', 'M22.973,23.25a4.474,4.474,0,0,0-8.449,0', 'M21,.75h.75a1.5,1.5,0,0,1,1.5,1.5V10.5a1.5,1.5,0,0,1-1.5,1.5h-4.5l-4.5,4.5V12h-3a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M13.874,3.375A1.875,1.875,0,1,1,15.749,5.25', 'M15.749,8.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  TeamMeeting: ['team-meeting', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.874 17.625 A2.625 2.625 0 1 0 7.124 17.625 A2.625 2.625 0 1 0 1.874 17.625 Z', 'M8.249,23.25a4.25,4.25,0,0,0-7.5,0', 'M16.874 17.625 A2.625 2.625 0 1 0 22.124 17.625 A2.625 2.625 0 1 0 16.874 17.625 Z', 'M23.249,23.25a4.25,4.25,0,0,0-7.5,0', 'M9.374 3.375 A2.625 2.625 0 1 0 14.624 3.375 A2.625 2.625 0 1 0 9.374 3.375 Z', 'M15.248,8.25a4.269,4.269,0,0,0-6.5,0', 'M9.05,19.707a8.277,8.277,0,0,0,5.944-.018', 'M6.348,6a8.217,8.217,0,0,0-2.6,6c0,.253.015.5.038.75', 'M20.211,12.75c.022-.248.038-.5.038-.75a8.214,8.214,0,0,0-2.6-6']],
  TeamChat: ['team-chat', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.749,21h1.5v2.25l3-2.25h4.5a1.5,1.5,0,0,0,1.5-1.5V15a1.5,1.5,0,0,0-1.5-1.5h-9a1.5,1.5,0,0,0-1.5,1.5v4.5A1.5,1.5,0,0,0,12.749,21Z', 'M2.348 16.875 A2.625 2.625 0 1 0 7.598 16.875 A2.625 2.625 0 1 0 2.348 16.875 Z', 'M9.2,23.25a4.474,4.474,0,0,0-8.449,0', 'M16.399 4.125 A2.625 2.625 0 1 0 21.649 4.125 A2.625 2.625 0 1 0 16.399 4.125 Z', 'M23.249,10.5a4.474,4.474,0,0,0-8.449,0', 'M16.499 15.75L20.249 15.75', 'M14.249 18L20.249 18', 'M11.249,8.25h-1.5V10.5l-3-2.25h-4.5a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5v4.5A1.5,1.5,0,0,1,11.249,8.25Z', 'M7.499 3L3.749 3', 'M9.749 5.25L3.749 5.25']],
  TeamExchangeChat: ['team-exchange-chat', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.249,8.25h-1.5V10.5l-3-2.25h-4.5a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5v4.5A1.5,1.5,0,0,1,11.249,8.25Z', 'M12.749,21h1.5v2.25l3-2.25h4.5a1.5,1.5,0,0,0,1.5-1.5V15a1.5,1.5,0,0,0-1.5-1.5h-9a1.5,1.5,0,0,0-1.5,1.5v4.5A1.5,1.5,0,0,0,12.749,21Z', 'M2.348 16.875 A2.625 2.625 0 1 0 7.598 16.875 A2.625 2.625 0 1 0 2.348 16.875 Z', 'M9.2,23.25a4.474,4.474,0,0,0-8.449,0', 'M16.399 4.125 A2.625 2.625 0 1 0 21.649 4.125 A2.625 2.625 0 1 0 16.399 4.125 Z', 'M23.249,10.5a4.474,4.474,0,0,0-8.449,0', 'M14.249 17.25L20.249 17.25', 'M18.749 15.75L20.249 17.25 18.749 18.75', 'M9.749 4.5L3.749 4.5', 'M5.249 3L3.749 4.5 5.249 6']],
  TeamMeetingMessageLock: ['team-meeting-message-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.509,23.25a28.433,28.433,0,0,0-4.177-1.734c-.7-.259-.585-2.087-.275-2.428a5.164,5.164,0,0,0,1.345-4,3.376,3.376,0,0,0-3.278-3.7,3.376,3.376,0,0,0-3.277,3.7,5.16,5.16,0,0,0,1.345,4c.31.341.425,2.169-.275,2.428l-1.168.431', 'M23.082,14.256a4.865,4.865,0,0,1,.07.828,5.164,5.164,0,0,1-1.345,4c-.31.341-.425,2.169.275,2.428l1.168.431', 'M13.5,23.244a28.745,28.745,0,0,1,4.166-1.728c.7-.259.586-2.087.276-2.428a4.575,4.575,0,0,1-1.261-2.694', 'M21,.75h.75a1.5,1.5,0,0,1,1.5,1.5V10.5a1.5,1.5,0,0,1-1.5,1.5h-4.5l-4.5,4.5V12h-3a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,9.75.75h1.5', 'M15.75,6.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.000 3.750 L19.500 3.750 L19.500 9.750 L12.000 9.750 Z', 'M13.75,3.75v-1a2,2,0,0,1,4,0v1']],
  TeamMeetingMessageWomenLock: ['team-meeting-message-women-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,.75h.75a1.5,1.5,0,0,1,1.5,1.5V10.5a1.5,1.5,0,0,1-1.5,1.5h-4.5l-4.5,4.5V12h-3a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M15.749,6.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.999 3.750 L19.499 3.750 L19.499 9.750 L11.999 9.750 Z', 'M13.749,3.75v-1a2,2,0,1,1,4,0v1', 'M2.999 15.750 A3.000 3.000 0 1 0 8.999 15.750 A3.000 3.000 0 1 0 2.999 15.750 Z', 'M3,15.75S3,19.5.749,19.5', 'M9,15.75s0,3.75,2.25,3.75', 'M1.755,23.25a4.5,4.5,0,0,1,8.488,0', 'M20.6,14.25A3,3,0,0,1,16.015,18', 'M21,15.75s0,3.75,2.25,3.75', 'M13.755,23.25a4.5,4.5,0,0,1,8.488,0']],
  TeamMeetingMessageWomenQuestion: ['team-meeting-message-women-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.999 15.750 A3.000 3.000 0 1 0 8.999 15.750 A3.000 3.000 0 1 0 2.999 15.750 Z', 'M3,15.75S3,19.5.749,19.5', 'M9,15.75s0,3.75,2.25,3.75', 'M1.755,23.25a4.5,4.5,0,0,1,8.488,0', 'M20.6,14.25A3,3,0,0,1,16.015,18', 'M21,15.75s0,3.75,2.25,3.75', 'M13.755,23.25a4.5,4.5,0,0,1,8.488,0', 'M21,.75h.75a1.5,1.5,0,0,1,1.5,1.5V10.5a1.5,1.5,0,0,1-1.5,1.5h-4.5l-4.5,4.5V12h-3a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M13.874,3.375A1.875,1.875,0,1,1,15.749,5.25', 'M15.749,8.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  UserManStress: ['user-man-stress', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.202 1.242L18.233 3.211 19.218 4.687 17.249 6.164', 'M3.749 1.242L5.718 3.211 4.733 4.687 6.702 6.164', 'M12.327 0.75L11.343 2.226 12.327 3.211', 'M18.7,23.25a6.75,6.75,0,0,0-13.5,0', 'M8.4,8.781a6.858,6.858,0,0,0,7.643,1.536', 'M7.827 10.875 A4.125 4.125 0 1 0 16.077 10.875 A4.125 4.125 0 1 0 7.827 10.875 Z', 'M11.952 16.5L11.952 20.25']],
  TeamMeetingMessageLock1: ['team-meeting-message-lock-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.974 15.750 A3.000 3.000 0 1 0 7.974 15.750 A3.000 3.000 0 1 0 1.974 15.750 Z', 'M9.2,23.25a4.474,4.474,0,0,0-8.449,0', 'M21.241,14.589a3,3,0,0,1-5.193,2.927', 'M22.7,23.25a4.474,4.474,0,0,0-8.449,0', 'M21,.75h.75a1.5,1.5,0,0,1,1.5,1.5V10.5a1.5,1.5,0,0,1-1.5,1.5h-4.5l-4.5,4.5V12h-3a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M15.749,6.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.999 3.750 L19.499 3.750 L19.499 9.750 L11.999 9.750 Z', 'M13.749,3.75v-1a2,2,0,1,1,4,0v1']],
  UserWomanStress: ['user-woman-stress', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.249 1.25L18.28 3.218 19.264 4.695 17.296 6.172', 'M3.749 1.242L5.718 3.211 4.733 4.687 6.702 6.164', 'M12.327 0.75L11.343 2.226 12.327 3.211', 'M7.828,10.986v1a5.906,5.906,0,0,1-.859,3.272', 'M16.075,10.986v1a5.905,5.905,0,0,0,.86,3.272', 'M7.84,11.2a5.486,5.486,0,0,0,4.112-1.9,5.486,5.486,0,0,0,4.112,1.9', 'M7.827 10.875 A4.125 4.125 0 1 0 16.077 10.875 A4.125 4.125 0 1 0 7.827 10.875 Z', 'M18.7,23.25a6.741,6.741,0,0,0-4.243-6.257L11.952,19.5,9.445,16.993A6.741,6.741,0,0,0,5.2,23.25']],
  TeamMeetingFlash: ['team-meeting-flash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.499 5.250 A3.000 3.000 0 1 0 7.499 5.250 A3.000 3.000 0 1 0 1.499 5.250 Z', 'M5.825,9.991A3.753,3.753,0,0,0,.749,13.5v2.25h1.5l.75,6H6l.75-6h1.5', 'M16.499 5.250 A3.000 3.000 0 1 0 22.499 5.250 A3.000 3.000 0 1 0 16.499 5.250 Z', 'M19.019,9.78a3.8,3.8,0,0,1,.48-.03,3.75,3.75,0,0,1,3.75,3.75v2.25h-1.5l-.75,6H18l-.75-6h-1.5', 'M14.029,6l-5.36,5.36a.375.375,0,0,0,.266.64h2.094v4.5l5.36-5.36a.375.375,0,0,0-.265-.64H14.029Z']],
  TeamMeetingMessageQuestion: ['team-meeting-message-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.509,23.25a28.433,28.433,0,0,0-4.177-1.734c-.7-.259-.585-2.087-.275-2.428a5.164,5.164,0,0,0,1.345-4,3.376,3.376,0,0,0-3.278-3.7,3.376,3.376,0,0,0-3.277,3.7,5.16,5.16,0,0,0,1.345,4c.31.341.425,2.169-.275,2.428l-1.168.431', 'M23.08,14.247a4.769,4.769,0,0,1,.072.837,5.164,5.164,0,0,1-1.345,4c-.31.341-.425,2.169.275,2.428l1.168.431', 'M13.5,23.244a28.745,28.745,0,0,1,4.166-1.728c.7-.259.586-2.087.276-2.428a4.575,4.575,0,0,1-1.261-2.694', 'M21,.75h.75a1.5,1.5,0,0,1,1.5,1.5V10.5a1.5,1.5,0,0,1-1.5,1.5h-4.5l-4.5,4.5V12h-3a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,9.75.75h1.5', 'M13.875,3.375A1.875,1.875,0,1,1,15.75,5.25', 'M15.75,8.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  TeamMeetingChat: ['team-meeting-chat', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.749,23.25a6.73,6.73,0,0,0-6.337-4.5h-.006a6.728,6.728,0,0,0-6.336,4.5', 'M12.851,11.031a6.858,6.858,0,0,0,7.643,1.536', 'M12.281 13.125 A4.125 4.125 0 1 0 20.531 13.125 A4.125 4.125 0 1 0 12.281 13.125 Z', 'M11.156,8.25h-1.5V10.5l-3-2.25h-4.5a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5v4.5A1.5,1.5,0,0,1,11.156,8.25Z', 'M7.406 3L3.656 3', 'M9.656 5.25L3.656 5.25', 'M2.499 15.750 A3.000 3.000 0 1 0 8.499 15.750 A3.000 3.000 0 1 0 2.499 15.750 Z', 'M8.162,21.132A4.436,4.436,0,0,0,5.5,20.25a4.487,4.487,0,0,0-4.225,3', 'M16.406 18.75L16.406 23.25']],
  TeamApproveDisapprove: ['team-approve-disapprove', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.348 16.875 A2.625 2.625 0 1 0 7.598 16.875 A2.625 2.625 0 1 0 2.348 16.875 Z', 'M9.2,23.25a4.474,4.474,0,0,0-8.449,0', 'M9,9.75V12L6,9.75H2.249a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5H10.5', 'M3.749 5.25L5.249 6.75 8.999 3.75', 'M16.400 16.875 A2.625 2.625 0 1 0 21.650 16.875 A2.625 2.625 0 1 0 16.400 16.875 Z', 'M14.8,23.25a4.474,4.474,0,0,1,8.449,0', 'M13.5,12h.75v2.25l3-2.25h4.5a1.5,1.5,0,0,0,1.5-1.5v-6a1.5,1.5,0,0,0-1.5-1.5H13.5A1.5,1.5,0,0,0,12,4.5v6A1.5,1.5,0,0,0,13.5,12Z', 'M19.499 9L15.749 6', 'M15.749 9L19.499 6']]
};
exports["default"] = _default;